import { ElementDefinition } from '@/runtime/shared/elements-definition';
import basicHtml from './stories/basic.story.html?raw';
import advancedHtml from './stories/advanced.story.html?raw';

import { cardPropsDocs, cardHeaderPropsDocs } from './';

/**
 * Docs definition for the Card component and its custom elements.
 *
 * Used by the docs site to render:
 * - API tables for `<e-card>`
 * - Example stories in the code playground
 */
export const definition: ElementDefinition = {
  componentName: 'Card',
  description: 'A card is a flexible and extensible content container.',
  elements: [
    {
      tag: 'e-card',
      description: 'The card wrapper. Will render either `article` by default',
      props: Object.values(cardPropsDocs)
    },
    {
      tag: 'e-card-header',
      description: 'The card header',
      props: Object.values(cardHeaderPropsDocs)
    }
  ],

  stories: [
    {
      id: 'basic',
      name: 'Basic',
      description: 'A basic accordion with multiple items.',
      html: basicHtml
    },
    {
      id: 'advanced',
      name: 'Advanced',
      description: 'An advanced accordion with additional features.',
      html: advancedHtml
    }
  ]
};
